import React, { Component } from "react";

import Avatar from '@material-ui/core/Avatar';
import Button from "@material-ui/core/Button";
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";

export default class ClientStaffSection extends Component {
  // shouldComponentUpdate(nextProps,nextState){
  //   console.log(nextProps.data.length,this.props.data.length)
  //   if(nextProps.data.length === this.props.data.length && nextProps.open === this.props.open){
  //     console.log("same props don't render don't render!");
  //     return false
  //   }
  //   else{
  //     console.log("new changes, render!")
  //     return true
  //   }

  // }

  render() {
    return (
      <React.Fragment>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 50
          }}
        >
          <Typography component="span" variant="h6" color="inherit">
            Client Staffs
          </Typography>
          {this.props.presentation ? null : (
            <Button
              color="primary"
              size="small"
              onClick={this.props.openDialog}
              disabled={this.props.disabled}
            >
              Add
            </Button>
          )}
        </div>
        {this.props.data.length < 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography component="span" variant="h6" color="inherit">
              No Staff added
            </Typography>
          </div>
        ) : (
          <>
            {this.props.disabled && (
              <LinearProgress
                color="primary"
                style={{ height: 2, marginTop: 20 }}
              />
            )}
            <Paper
              style={
                this.props.disabled
                  ? { padding: "6px 0" }
                  : { padding: "6px 0", marginTop: 20 }
              }
            >
              <List>
                {this.props.data.map((item, i) => {
                  return (
                    <ListItem
                      key={i}
                    >
                      <ListItemIcon>
                        <Avatar
                          style={{
                            backgroundColor: "rgba(67, 160, 71,0.1)",
                            color: "rgb(67, 160, 71)"
                          }}
                        >
                          {item.firstname[0].toUpperCase() +
                            item.lastname[0].toUpperCase()}
                        </Avatar>
                      </ListItemIcon>
                      {this.props.presentation ? null : (
                        <ListItemSecondaryAction>
                          {this.props.edit ? (
                              <IconButton disabled={this.props.disabled}>
                                <DeleteIcon
                                  onClick={() =>
                                    this.props.deleteStaff(item.id)
                                  }
                                />
                              </IconButton>
                          ) : (
                            <IconButton disabled={this.props.disabled}>
                              <CloseIcon
                                onClick={() =>
                                  this.props.removeItem("staffs", i)
                                }
                              />
                            </IconButton>
                          )}
                        </ListItemSecondaryAction>
                      )}
                      <ListItemText
                        primary={`${item.firstname} ${item.lastname}`}
                        secondary={`${item.position} — ${item.email}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Paper>
          </>
        )}
      </React.Fragment>
    );
  }
}
